// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: 'AIzaSyBrwHJFZk39tVaOSkGkGtYqebCrdCqiNBc',
  authDomain: 'store-bticino.firebaseapp.com',
  projectId: 'store-bticino',
  storageBucket: 'store-bticino.appspot.com',
  messagingSenderId: '601719920241',
  appId: '1:601719920241:web:5cf808fb310c5c56cb2dd0',
  measurementId: 'G-2XFYF64ZFL',
  debug_mode: process.env.DEV
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
// const analytics = isSupported().then(yes => (yes ? getAnalytics(app) : null))

export default analytics

export function sendEvent(event, params) {
  logEvent(analytics, event, params)
}
